import { fewestAllowed } from '@foodrun/shared';

/**
 * A group's rules, said as a sentence.
 *
 * Kept apart from the screen so hot reloading still works there, and because
 * this is the one place that decides what "at least 0, at most 1, required"
 * actually means — the server's checker follows the same reading, and the two
 * disagreeing would mean a screen that promises something the till refuses.
 */
export function describeRules(group) {
  const max = Number(group.max_selections) || 0;

  // The same sum the till and the server use, rather than a third copy of it.
  const floor = fewestAllowed(group);

  if (floor === 0 && max === 1) return 'Up to one';
  if (floor === 0 && max > 1) return `Up to ${max}`;
  // A maximum of nought is read as no limit rather than as nothing allowed,
  // so a mis-set group does not silently make a dish unsellable.
  if (floor === 0) return 'Any number';
  if (floor === max) return floor === 1 ? 'Exactly one, required' : `Exactly ${floor}, required`;
  if (max > 0) return `${floor} to ${max}, required`;
  return `At least ${floor}, required`;
}
